import { useTranslation } from 'react-i18next';
import { Icon } from '@squareup/shared-ui-react';
import styles from './FdicDisclosure.module.css';

export const FdicDisclosure = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Icon iconName="fdic" />
      <p data-testid="fdic-description" className={styles.description}>
        {t('bankingShared.fdic')}
      </p>
    </div>
  );
};
